import { render, staticRenderFns } from "./private-sales-list.vue?vue&type=template&id=573a74d4&"
import script from "./private-sales-list.vue?vue&type=script&lang=js&"
export * from "./private-sales-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports